<template>
  <div class="person-wrap">
    <!-- 头像 -->
    <div class="avatar" :class="{editable:editable}">
      <!-- 头像图片 -->
      <img
        class="avatar_img"
        :style="{width:imgSize/100 + 'rem'}"
        :src="user.headPicUrl || require('@/assets/images/default.png')"
        title="头像"
      />
      <!-- 编辑选项 -->
      <div class="avatar_option">
        <!-- 编辑 -->
        <i class="iconfont icon-bianji1" @click="onEdit"></i>
        <!-- 删除 -->
        <i class="iconfont icon-shanchu1" @click="onDelete"></i>
      </div>
    </div>
    <!-- 姓名 -->
    <div class="name" :style="{fontSize: nameFontSize/100 + 'rem'}">{{user.userName}}</div>
    <!-- 职位 -->
    <div class="job" :style="{fontSize: jobFontSize/100 + 'rem'}">{{user.typeName?user.typeName:'暂无职务'}}</div>
    <!-- 电话 -->
    <div class="phone" :style="{fontSize: phoneFontSize/100 + 'rem'}" v-if="showPhone">{{user.phoneNO}}</div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    user: {
      type: Object,
      default() {
        return {};
      }
    },
    showPhone: {
      type: Boolean,
      default: true
    },
    nameFontSize: {
      type: Number,
      default: 30
    },
    jobFontSize: {
      type: Number,
      default: 24
    },
    phoneFontSize: {
      type: Number,
      default: 24
    },
    editable: {
      type: Boolean,
      default: true
    },
    imgSize: {
      type: Number,
      default: 100
    }
  },
  data() {
    return {};
  },
  watch: {},
  computed: {},
  methods: {
    onDelete() {
      this.$emit("on-delete");
    },
    onEdit() {
      this.$emit("on-edit");
    }
  },
  created() {},
  mounted() {}
};
</script>
<style lang="less" scoped>
.person-wrap {
  .flex(center, @flexDirection:column);
}
.avatar {
  position: relative;
  line-height: 0;
}
.avatar_img,
.avatar_option {
  height: auto;
  border-radius: 50%;
}
.avatar_option {
  display: none;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  & .iconfont {
    color: #fff;
    cursor: pointer;
  }
  & .icon-bianji1 {
    font-size: 28px;
  }
  & .icon-shanchu1 {
    font-size: 30px;
  }
}
.editable:hover .avatar_option {
  .flex(center, space-evenly);
}
.name {
  color: #4b4b4b;
  font-size: 0.3rem;
  font-weight: bold;
  margin-top: 20px;

  .ellipsis(8em);
}
.job {
  color: #666;
  font-size: 0.24rem;
  letter-spacing: 3px;

  max-width: 12em;
  .textWrap();
}
.phone {
  color: #ff7b44;
  font-size: 0.24rem;
}
</style>